export enum InvoiceItemType {

    BASIC = 0,
    FLAT_RATE = 1,
    TIME = 2
}